import { render, staticRenderFns } from "./FinalizarAvisosVencimentoContrato.vue?vue&type=template&id=cefe28ea&"
import script from "./FinalizarAvisosVencimentoContrato.vue?vue&type=script&lang=js&"
export * from "./FinalizarAvisosVencimentoContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports